<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import satdosyafirma from "@/models/satdosyafirma";
import formtreeselect from "../formcomponet/formtreeselect.vue";
import ofirmaAddEdit from "../ofirma/addedit.vue";
export default {
  mixins: [apibtoast, apigeneric, satdosyafirma],
  props: ["FormData", "AddEdit", "satdosyaId","Firmaturu"],
  data() {
    return { 
      ofirma:false
    };
  },
  components: {
    Loader,
    formtreeselect,
    ofirmaAddEdit
  },
  watch: {
    FormData() { 
     
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.FormData.Firmaturu = this.Firmaturu;
         this.FormData.Dosyaid = this.satdosyaId;
        if (this.AddEdit == "Add") {
          this.Post("satdosyafirma", this.FormData).then((res) => {
            if(res){
                this.$emit("TableUpdate"); 
            }
          });
          this.$bvModal.hide("satdosyafirma");
        } else {
          this.Update("satdosyafirma", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate"); 
              this.$emit("Update", this.FormData);
              this.$bvModal.hide("satdosyafirma");

            }
          });
        }
      }
    },
    Get() {
this.FormDataType.Firmaid.ComboDataArray = []
      let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
    this.ActionsGet({ Service: "OFirma", Page: Page }).then((res) => {

      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Firmaid.ComboDataArray.push({
          id: res.Data[i].Id,
          label: res.Data[i].Firmaadi,
        });
      }
    });
    },
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="satdosyafirma"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('satdosyafirma.AddEdit.FormTitleEdit')
          : $t('satdosyafirma.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
    <div class="row">
          <div class="text-sm-end">
      
               <button
                      type="button"
                      class="btn btn-primary btn-rounded mb-2 me-2"
                      v-b-modal.ofirma
                      @click="(DataUpdate = ofirmaData), (AddEdit = 'Add'),(ofirma = true)"
                    > 
                      <i class="mdi mdi-plus me-1"></i>{{$t('ofirma.Page.YeniFirmaTanimla')}}
                </button>
          </div>
    </div>
      <Form @submit.prevent="onSubmit">  
        <formtreeselect
          :FormDataType="FormDataType.Firmaid"
          :Value="FormData.Firmaid"
          :v="$v.FormData.Firmaid"
          @input="FormData.Firmaid = $event"
        />

        <button class="btn btn-primary" type="submit">
          {{ $t("satdosyafirma.AddEdit.Button") }}
        </button>
      </Form>

      <ofirmaAddEdit v-if="ofirma"  AddEdit="DosyaAdd" @TableUpdate="Get()" />

    </b-modal>
  </Loader>
</template>
